<template>
  <v-card
    :color="color"
    :flat="flat"
    :tile="tile"
    :to="to"
  >
    <v-card-text
      class="pa-0"
    >
      <v-container
        fluid
      >
        <v-row
          align="center"
          class="flex-nowrap"
        >
          <v-col
            class="flex-grow-0 flex-shrink-0"
          >
            <div
              :style="{ height: '64px', position: 'relative', width: '64px' }"
            >
              <v-avatar
                class="elevation-3"
                size="64"
              >
                <img
                  :src="`${config.IMAGE_SERVICE_URL}/servers/${item.data.id}/icon.png`"
                >
              </v-avatar>
              <router-link
                :style="{ bottom: 0, position: 'absolute', right: 0 }"
                :to="{ name: 'gameServer.index', params: { gameIdentifier: game.identifier } }"
              >
                <v-tooltip
                  open-delay="100"
                  top
                >
                  <template
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-avatar
                      class="elevation-3"
                      size="28"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <img
                        :src="`${config.IMAGE_SERVICE_URL}/games/${game.identifier}/icon.png`"
                      >
                    </v-avatar>
                  </template>
                  <span>
                    {{ game.name }}
                  </span>
                </v-tooltip>
              </router-link>
            </div>
          </v-col>
          <v-col
            class="overflow-hidden"
          >
            <div
              class="grey--text text--lighten-1 text-truncate"
            >
              <v-tooltip
                open-delay="100"
                top
              >
                <template
                  v-slot:activator="{ on, attrs }"
                >
                  <span
                    v-bind="attrs"
                    v-on="on"
                    @click.prevent="[copyToClipboard(hostAndPort), $notify('info', $t('copied_to_clipboard'))]"
                  >
                    <v-icon
                      class="mr-1"
                      color="grey"
                      x-small
                    >
                      public
                    </v-icon>
                    {{ hostAndPort }}
                  </span>
                </template>
                <span>
                  {{ $t('copy_to_clipboard') }}
                </span>
              </v-tooltip>
            </div>
            <h3
              class="my-1 text--primary text-truncate"
            >
              {{ item.data.name || 'Unknown' }}
            </h3>
            <div>
              <v-avatar
                class="mr-1"
                :color="item.data.is_online ? 'green' : 'red'"
                size="8"
              />
              <span
                v-if="item.data.is_online"
              >
                {{ $tc('players_online', item.data.player_count) }}
              </span>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import copyToClipboard from '@/helpers/copyToClipboard'

export default {
  name: 'ServerPreviewCard',

  props: {
    color: {
      default: 'white',
      type: String,
    },
    flat: {
      default: false,
      type: Boolean,
    },
    game: {
      required: true,
      type: Object,
    },
    item: {
      required: true,
      type: Object,
    },
    link: {
      default: false,
      type: Boolean,
    },
    tile: {
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      config: {
        IMAGE_SERVICE_URL: process.env.IMAGE_SERVICE_URL || 'https://img.servers.gg',
      },
    }
  },

  computed: {
    hostAndPort () {
      return `${this.item.data.host}:${this.item.data.port}`
    },

    to () {
      if (this.link === false) {
        return null
      }

      return {
        name: 'server.show',
        params: {
          serverId: this.item.data.id,
        },
      }
    },
  },

  methods: {
    copyToClipboard,
  },
}
</script>
